<template>
  <div class="heading reveal" v-reveal :class="align">
    <span v-if="eyebrow" class="eyebrow">{{ eyebrow }}</span>
    <h2 class="h2 heading-title">
      <slot>{{ title }}</slot>
    </h2>
    <p v-if="desc" class="heading-desc">{{ desc }}</p>
  </div>
</template>

<script>
export default {
  name: 'SectionHeading',
  props: {
    eyebrow: { type: String, default: '' },
    title: { type: String, default: '' },
    desc: { type: String, default: '' },
    align: { type: String, default: 'left' } // left | center
  }
}
</script>

<style lang="scss" scoped>
.heading {
  margin-bottom: 46px;

  &.center { text-align: center; }
  &.center .eyebrow { justify-content: center; }
  &.center .heading-desc { margin-left: auto; margin-right: auto; }
}

.heading-title { margin-top: 16px; }
.heading-desc {
  margin-top: 16px;
  max-width: 720px;
  font-size: 16px;
  line-height: 1.9;
  color: var(--txt-2);
}

@media (max-width: 760px) {
  .heading { margin-bottom: 30px; }
  .heading-desc { font-size: 14.5px; }
}
</style>
